import React, { useState, useRef } from "react";
import { Link, graphql } from "gatsby";
import axios from "axios";

import moment from "moment";
import Container from "../components/container";
import GraphQLErrorList from "../components/graphql-error-list";
import BlockContent from "../components/block-content";

import Logo from "../svg/logo.svg";
import { FormControl, FormGroup, FormLabel, FormControlLabel, Checkbox, RadioGroup, Radio } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { TimeRangeSelector } from "../components/Utils/TimeRangeSelector";
import { notificationService } from "../services/Notifications/Notifications";
import { NotificationsContainer } from "../services/Notifications/Notifications";
import { formattedHours } from "../lib/helpers";

import SEO from "../components/seo";
import Layout from "../containers/layout";
import "../styles/clinicsInfo.scss";
import "../components/Contact/Contact.scss";

export const query = graphql`
  query notdienstSuchePageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
      mainImage {
        alt
        caption
        asset {
          _id
        }
        crop {
          _key
          _type
          top
          bottom
          left
          right
        }
        hotspot {
          _key
          _type
          x
          y
          height
          width
        }
      }
      clinicsFormReceiverEmail
    }

    infoMessages: sanityInfoMessages {
      clinicsFormErrorMessage
      clinicsFormSuccessMessage
    }

    menu: sanityMenu(_id: { regex: "/(drafts.|)menu/" }) {
      id
      menuitems {
        _key
        _type
        name
        url
        menutype
      }
      menuName
    }

    clinicsForm: sanityClinicsForm {
      title
      _rawInfoText
      _rawInfoTextError
      _rawInfoTextSuccess
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
}));

const ClinicsInfo = (props) => {
  const { data, errors } = props;

  let btnRef = useRef();

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;
  const infoMessages = (data || {}).infoMessages;
  const menu = (data || {}).menu;
  const clinicsForm = (data || {}).clinicsForm;

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }

  const classes = useStyles();

  const initTimeState = {
    monday: {
      label: "Montag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    tuesday: {
      label: "Dienstag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    wednesday: {
      label: "Mittwoch",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    thursday: {
      label: "Donnerstag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    friday: {
      label: "Freitag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    saturday: {
      label: "Samstag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
    sunday: {
      label: "Sonntag",
      startTime: moment().toISOString(),
      endTime: moment().toISOString(),
      open: false,
    },
  };

  const contactInfoInitState = {
    name: "",
    email: "",
    addressStreet: "",
    addressNumber: "",
    addressZip: "",
    addressCity: "",
    tel: "",
    url: "",
  };

  const clinicTypeInit = {
    emergencyClinic: false,
    clinic: false,
    mobileEmergencyClinic: false
  }

  const [formStep, setFormStep] = useState(0);
  const [formState, setFormState] = useState({
    success: false,
    error: false,
  });

  const [contactInfo, setContactInfo] = useState(contactInfoInitState);
  const [validationErrors, setValidationErrors] = useState({
    email: {
      valid: true,
      label: "",
    },
  });

  const [datenschutz, setDatenschutz] = useState(false);
  const [agb, setAgb] = useState(false);

  const [emergencyTelInfo, setEmergencyTelInfo] = useState(false);
  const [emailInfo, setEmailInfo] = useState(false);

  const [clinicType, setClinicType] = useState('');
  const [openingHoursToggle, setOpeningHoursToggle] = useState(false);
  const [emergencyHoursToggle, setEmergencyHoursToggle] = useState(false);

  const [openingHours, setOpeningHours] = useState(initTimeState);
  const [emergencyHours, setEmergencyHours] = useState(initTimeState);

  const handleContactInfoChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setContactInfo({ ...contactInfo, [name]: value });
  };

  const handleClinicType = (e) => {
    const value = e.target.value
    setClinicType(value)
    console.log('current clinic type: ', clinicType);
  }


  const changeOpeningHoursStartTime = (value, day) => {
    setOpeningHours({ ...openingHours, [day]: { ...openingHours[day], startTime: value } });
  };

  const changeOpeningHoursEndTime = (value, day) => {
    setOpeningHours({ ...openingHours, [day]: { ...openingHours[day], endTime: value } });
  };

  const changeEmergencyHoursStartTime = (value, day) => {
    setEmergencyHours({ ...emergencyHours, [day]: { ...emergencyHours[day], startTime: value } });
  };

  const changeEmergencyHoursEndTime = (value, day) => {
    setEmergencyHours({ ...emergencyHours, [day]: { ...emergencyHours[day], endTime: value } });
  };

  const toggleOpeningHoursOpen = (value, day) => {
    setOpeningHours({
      ...openingHours,
      [day]: { ...openingHours[day], open: !openingHours[day].open },
    });
  };

  const toggleEmergencyHoursOpen = (value, day) => {
    setEmergencyHours({
      ...emergencyHours,
      [day]: { ...emergencyHours[day], open: !emergencyHours[day].open },
    });
  };

  const validateEmail = () => {
    setValidationErrors({
      ...validationErrors,
      email: { ...validationErrors.email, label: "", valid: true },
    });

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(contactInfo.email)) {
      setValidationErrors({
        ...validationErrors,
        email: {
          ...validationErrors.email,
          label: "Bitte gib eine gültige E-Mail Adresse ein.",
          valid: false,
        },
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (btnRef.current) {
      btnRef.current.setAttribute("disabled", "disabled");
    }

    const formattedOpeningHours = formattedHours(openingHours);
    const formattedEmergencyHours = formattedHours(emergencyHours);

    const receiverEmail = site.clinicsFormReceiverEmail;

    let { name, email, addressStreet, addressNumber, addressZip, addressCity, tel, url } =
      contactInfo;

    let data = {
      receiverEmail,
      name,
      email,
      addressStreet,
      addressNumber,
      addressZip,
      addressCity,
      tel,
      url,
      clinicType,
      openingHoursToggle,
      emergencyHoursToggle,
      formattedOpeningHours,
      formattedEmergencyHours,
      emergencyTelInfo,
      emailInfo,
    };

    axios
      .post("/.netlify/functions/submitClinic", JSON.stringify(data))
      .then((response) => {
        handleSuccess();
      })
      .catch((err) => {
        handleError();
      });
  };

  const resetForm = () => {
    setDatenschutz(false);
    setAgb(false);
    setEmergencyTelInfo(false);
    setEmailInfo(false);
    setOpeningHours(initTimeState);
    setEmergencyHours(initTimeState);
    setContactInfo(contactInfoInitState);
  };

  const handleSuccess = async () => {
    notificationService.success(infoMessages.clinicsFormSuccessMessage);
    setFormState({ ...formState, success: true, error: false });
    await resetForm();
    setFormStep(0);
  };

  const handleError = async () => {
    notificationService.error(infoMessages.clinicsFormErrorMessage);
    setFormState({ ...formState, success: false, error: true });
    await resetForm();
    setFormStep(0);
  };

  return (
    <Layout menus={menu}>
      <SEO title={site.title} description={site.description} keywords={site.keywords} />
      <Container>
        <section className="clinicsInfo">
          <div className="clinicsInfo--backWrapper">
            <Link to="/">
              <button className="clinicsInfo--backWrapper__button button">Zurück</button>
            </Link>
          </div>
          <div className="clinicsInfo--card card">
            {!formState.success && !formState.error && (
              <div className="clinicsInfo--header">
                <h1>{clinicsForm.title}</h1>
                <BlockContent blocks={clinicsForm._rawInfoText || []} />
              </div>
            )}
            {formState.success && (
              <div className="clinicsInfo--headerSuccess">
                <h1>Sehr geehrte Kleintierpraxis- und Klinikinhaber,</h1>
                <BlockContent blocks={clinicsForm._rawInfoTextSuccess || []} />
              </div>
            )}
            {formState.error && (
              <div className="clinicsInfo--headerError">
                <h1>Sehr geehrte Kleintierpraxis- und Klinikinhaber,</h1>
                <BlockContent blocks={clinicsForm._rawInfoTextError || []} />
              </div>
            )}
          </div>
          {!formState.success && (
            <div className="clinicsInfo--card card">
              <div className="clinicsInfo--grid">
                <h1 className="clinicsInfo--headline">
                  {formStep === 0 ? "Ich möchte meine Praxis/Klinik anmelden" : ""}
                  {formStep === 1 ? "Weitere Angaben" : ""}
                  {formStep === 2 ? "Angegebene Daten" : ""}
                </h1>
                <div className="clinicsInfo--logo">
                  <Logo />
                </div>

                <form name="Klinik Anmeldung" className="clinicsInfo--form" onSubmit={handleSubmit}>
                  {formStep === 0 ? (
                    <div className="clinicsInfoForm--grid">
                      <p className="form-field clinicsInfo--name">
                        <label htmlFor="name" className="control-label">
                          <span className="label">Name der Praxis/Klinik</span>
                          <input
                            type="text"
                            name="name"
                            required="required"
                            onChange={handleContactInfoChange}
                            value={contactInfo.name}
                          />
                        </label>
                      </p>

                      <p className="form-field clinicsInfo--email">
                        <label htmlFor="email" className="control-label">
                          <span className="label">E-Mail</span>
                          <input
                            type="email"
                            name="email"
                            required="required"
                            onChange={handleContactInfoChange}
                            onBlur={validateEmail}
                            value={contactInfo.email}
                          />
                        </label>
                        <span className="clinicsInfo__validation--error">
                          {validationErrors.email.label}
                        </span>
                      </p>

                      <div className="clinicsInfo--inlineFlex clinicsInfo--streetAndNumber">
                        <p className="form-field clinicsInfo--addressStreet">
                          <label htmlFor="addressStreet" className="control-label">
                            <span className="label">Strasse</span>
                            <input
                              type="text"
                              name="addressStreet"
                              required="required"
                              onChange={handleContactInfoChange}
                              value={contactInfo.addressStreet}
                            />
                          </label>
                        </p>

                        <p className="form-field clinicsInfo--addressNumber">
                          <label htmlFor="addressNumber" className="control-label">
                            <span className="label">Nr.</span>
                            <input
                              type="text"
                              name="addressNumber"
                              required="required"
                              onChange={handleContactInfoChange}
                              value={contactInfo.addressNumber}
                            />
                          </label>
                        </p>
                      </div>

                      <p className="form-field clinicsInfo--addressZip">
                        <label htmlFor="addressZip" className="control-label">
                          <span className="label">PLZ</span>
                          <input
                            type="number"
                            name="addressZip"
                            required="required"
                            onChange={handleContactInfoChange}
                            value={contactInfo.addressZip}
                          />
                        </label>
                      </p>

                      <p className="form-field clinicsInfo--addressCity">
                        <label htmlFor="addressCity" className="control-label">
                          <span className="label">Stadt</span>
                          <input
                            type="text"
                            name="addressCity"
                            required="required"
                            onChange={handleContactInfoChange}
                            value={contactInfo.addressCity}
                          />
                        </label>
                      </p>

                      <p className="form-field clinicsInfo--tel">
                        <label htmlFor="tel" className="control-label">
                          <span className="label">Tel.</span>
                          <input
                            type="tel"
                            name="tel"
                            required="required"
                            onChange={handleContactInfoChange}
                            value={contactInfo.tel}
                          />
                        </label>
                      </p>

                      <p className="form-field clinicsInfo--url">
                        <label htmlFor="url" className="control-label">
                          <span className="label">Webseite</span>
                          <input
                            type="text"
                            name="url"
                            placeholder="zb. https://www.tiernotdienst.de"
                            onChange={handleContactInfoChange}
                            value={contactInfo.url}
                          />
                        </label>
                      </p>
                    </div>
                  ) : null}

                  {formStep === 1 && (
                    <>
                      <FormControl component="fieldset" className={`${classes.formControl}`}>
                        <FormLabel component="legend">Art der Praxis/Klinik</FormLabel>
                        <RadioGroup
                          aria-label="typeOfClinic"
                          name="typeOfClinic"
                          value={clinicType}
                          onChange={handleClinicType}
                        >
                          <FormControlLabel
                            className={classes.formLabel}
                            value="clinic"
                            control={<Radio />}
                            label={'Klinik'}
                          />
                          <FormControlLabel
                            className={classes.formLabel}
                            value="emergencyClinic"
                            control={<Radio />}
                            label={'Notfallpraxis'}
                          />
                          <FormControlLabel
                            className={classes.formLabel}
                            value="mobileEmergencyClinic"
                            control={<Radio />}
                            label={'Mobile Notfallpraxis'}
                          />
                        </RadioGroup>

                      </FormControl>
                      <FormControl component="fieldset" className={`${classes.formControl}`}>
                        <FormLabel component="legend">
                          Öffnungszeiten und/oder Notdienstzeiten hinterlegen
                        </FormLabel>
                        <FormGroup className={`${classes.clinicsInfo} clinicForm__legal`}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={openingHoursToggle}
                                onChange={() => setOpeningHoursToggle(!openingHoursToggle)}
                                name="openingHoursToggle"
                              />
                            }
                            label="Öffnungszeiten"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={emergencyHoursToggle}
                                onChange={() => setEmergencyHoursToggle(!emergencyHoursToggle)}
                                name="emergencyHoursToggle"
                              />
                            }
                            label="Notdienstszeiten"
                          />
                        </FormGroup>
                      </FormControl>

                      <div className="clinicsInfoFormPage2--grid">
                        {openingHoursToggle && (
                          <div className="openingHours__grids">
                            <h2>Öffnungszeiten</h2>

                            {Object.entries(openingHours).map(([key, value]) => {
                              return (
                                <TimeRangeSelector
                                  key={key}
                                  title={value.label}
                                  state={value}
                                  day={key}
                                  changeStartTime={changeOpeningHoursStartTime}
                                  changeEndTime={changeOpeningHoursEndTime}
                                  handleOpen={toggleOpeningHoursOpen}
                                  open={value.open}
                                />
                              );
                            })}
                          </div>
                        )}

                        {emergencyHoursToggle && (
                          <div className="openingHours__grid">
                            <h2>Notdienstzeiten</h2>

                            {Object.entries(emergencyHours).map(([key, value]) => {
                              return (
                                <TimeRangeSelector
                                  key={key}
                                  title={value.label}
                                  state={value}
                                  day={key}
                                  changeStartTime={changeEmergencyHoursStartTime}
                                  changeEndTime={changeEmergencyHoursEndTime}
                                  handleOpen={toggleEmergencyHoursOpen}
                                  open={value.open}
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div>
                        <FormControl component="fieldset" className={`${classes.formControl}`}>
                          <FormLabel component="legend">Persönliche Einstellungen</FormLabel>
                          <FormGroup className={`${classes.clinicsInfo} clinicForm__legal`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={emergencyTelInfo}
                                  onChange={() => setEmergencyTelInfo(!emergencyTelInfo)}
                                  name="emergencyTelInfo"
                                />
                              }
                              label="Notfälle bitte telefonisch ankündigen"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={emailInfo}
                                  onChange={() => setEmailInfo(!emailInfo)}
                                  name="emailInfo"
                                />
                              }
                              label="Kunden-/ Patientendaten vorab per E-mail erhalten"
                            />
                          </FormGroup>
                        </FormControl>

                        <FormControl component="fieldset" className={`${classes.formControl}`}>
                          <FormLabel component="legend">
                            Ich stimme zu, dass meine Angaben aus dem Kontaktformular zur
                            Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die Daten
                            werden nach abgeschlossener Bearbeitung Ihrer Anfrage umgehend gelöscht.
                            Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in
                            unserer Datenschutzerklärung. *
                          </FormLabel>
                          <FormGroup className={`${classes.clinicsInfo} clinicForm__legal`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={datenschutz}
                                  onChange={() => setDatenschutz(!datenschutz)}
                                  name="datenschutz"
                                />
                              }
                              label="Datenschutz *"
                            />
                          </FormGroup>
                        </FormControl>
                      </div>
                    </>
                  )}

                  {formStep === 2 && (
                    <>
                      <div className="clinicResult__topWrapper">
                        <div className="clinicResult__contactDataWrapper">
                          <h3>Kontaktdaten</h3>
                          <div>Adresse:</div>
                          <div>{contactInfo.name}</div>
                          <div>
                            {contactInfo.addressStreet} {contactInfo.addressNumber}
                          </div>
                          <div>
                            {contactInfo.addressZip} {contactInfo.addressCity}
                          </div>
                          <br />
                          <div>
                            <span>E-Mail: </span>
                            {contactInfo.email}
                          </div>
                          <div>
                            <span>Tel: </span>
                            {contactInfo.tel}
                          </div>
                          <div>
                            <span>Webseite: </span>
                            {contactInfo.url}
                          </div>
                        </div>

                        <div>
                          <h3>Einwilligungen</h3>
                          <div>
                            <span>Notfälle bitte telefonisch ankündigen: </span>{" "}
                            {emergencyTelInfo ? "Ja" : "Nein"}
                          </div>
                          <div>
                            <span>Kunden-/ Patientendaten vorab per E-mail erhalten: </span>{" "}
                            {emailInfo ? "Ja" : "Nein"}
                          </div>
                        </div>
                      </div>

                      <div className="clinicResult__timeWrapper">
                        {openingHoursToggle && (
                          <div className="clinicResult__hoursWrapper">
                            <h3>Öffnungszeiten</h3>
                            {Object.entries(openingHours).map(([key, value]) => {
                              return (
                                <div key={key}>
                                  <div className="clinicResult__times">
                                    <span>{value.label}</span>
                                    {!value.open ? (
                                      "geschlossen"
                                    ) : (
                                      <>
                                        {moment(value.startTime).format("H:mm")} -{" "}
                                        {moment(value.endTime).format("H:mm")}
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {emergencyHoursToggle && (
                          <div className="clinicResult__hoursWrapper">
                            <h3>Notdienstzeiten</h3>
                            {Object.entries(emergencyHours).map(([key, value]) => {
                              return (
                                <div key={key}>
                                  <div className="clinicResult__times">
                                    <span>{value.label}</span>
                                    {!value.open ? (
                                      "geschlossen"
                                    ) : (
                                      <>
                                        {moment(value.startTime).format("H:mm")} -{" "}
                                        {moment(value.endTime).format("H:mm")}
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <div className="buttonsGrid">
                    {formStep > 0 && (
                      <button
                        className="clinicsInfo--back button"
                        onClick={(e) => {
                          e.preventDefault();
                          setFormStep(formStep - 1);
                        }}
                      >
                        Zurück
                      </button>
                    )}
                    {formStep !== 2 && (
                      <button
                        className="clinicsInfo--submit button"
                        onClick={(e) => {
                          e.preventDefault();
                          if (formStep === 0) {
                            if (!contactInfo.email) {
                              notificationService.error(
                                "Bitte Email Addresse ausfüllen um fortzusetzen"
                              );

                              return;
                            }

                            setFormStep(formStep + 1);
                          }
                          if (formStep === 1) {
                            if (!datenschutz) {
                              notificationService.error(
                                "Bitte Datenschutz akzeptieren um fortzusetzen"
                              );

                              return;
                            }

                            setFormStep(formStep + 1);
                          }
                          setFormStep(formStep + 1);
                        }}
                      >
                        Weiter
                      </button>
                    )}
                    {formStep === 2 && (
                      <button ref={btnRef} className="clinicsInfo--submit button" type="submit">
                        Absenden
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </section>
      </Container>
      <NotificationsContainer />
    </Layout>
  );
};

export default ClinicsInfo;
